/*
 * VERON · Saison-Messung (Saison-Konzept Kap. 10.2, Entscheidung E-15; Paket B, Nachbesserung 11.10.2026)
 *
 * Meldet Ansicht und Klick der Saison-Flächen der Startseite als Kundenereignisse über
 * Shopify.analytics.publish (Web-Pixel-API von Shopify):
 *   veron_promotion_view   { promotion_name, creative_slot, items: [{ item_id, saison_jetzt }] }
 *   veron_promotion_select { promotion_name, creative_slot, link_url, item: { item_id, saison_jetzt } | null }
 * Flächen = Elemente mit data-veron-promo (Hero-Knöpfe hero-damen/-herren, Kacheln kachel-damen/-herren,
 * Schienen saison-highlights-damen/-herren, neu, thema-<code>, rueckfall-damen), data-veron-promo-slot = Ort.
 * Ansicht: einmal je Seitenaufruf, sobald die Fläche zur Hälfte im Bild ist. saison_jetzt kommt aus
 * data-veron-jetzt der Produktkarte (veron.jetzt_tragen: ja/nein).
 *
 * Das Theme sendet selbst NICHTS an Google und setzt keine Cookies. Weitergeleitet an GA4 (G-B62NSMB53C,
 * view_promotion/select_promotion) wird erst durch das eigene Pixel unter Einstellungen → Kundenereignisse,
 * das nur mit Analyse-Einwilligung läuft — Code und Einrichtung: doku/ga4-saison-pixel.js.
 * Geprüft im Render-Test tests/saison/saison_render.js (Abschnitt E, nachgestellter DOM).
 *
 * Mängel 11.10.2026 (Linse Dauer M5): Flächen, die ERST NACH dem Laden entstehen - das Schubfach „Passt dazu“
 * (data-veron-promo="schubfach") nach „In den Warenkorb“, wenn cart-drawer-section neu gerendert wird -, beobachtet ein
 * MutationObserver mit; der Klick-Hörer steht immer (vorher: ohne Fläche beim Start gar keiner). Jede neu gerenderte
 * Fläche meldet ihre Ansicht einmal. Damit ist die Klickrate von „Passt dazu“ messbar (Bedingung für Stufe 4b).
 * Geprüft in tests/saison/stufe4_render.js (Abschnitt M).
 */
(function () {
  'use strict';
  if (window.__veronSaisonMessung) return;
  window.__veronSaisonMessung = true;

  // Ist die Web-Pixel-API (Shopify.analytics.publish) beim ersten Ereignis noch nicht geladen, werden die Ereignisse
  // höchstens 10 s lang alle 0,5 s nachgereicht, danach verworfen. Messung darf die Seite nie stören (try/catch).
  var warte = [], versuche = 0;
  function api() {
    var a = window.Shopify && window.Shopify.analytics;
    return a && typeof a.publish === 'function' ? a : null;
  }
  function nachreichen() {
    setTimeout(function () {
      var a = api();
      if (a) {
        var w = warte;
        warte = [];
        for (var i = 0; i < w.length; i++) { try { a.publish(w[i][0], w[i][1]); } catch (e) { /* still */ } }
      } else if (++versuche < 20) {
        nachreichen();
      } else {
        warte = [];
      }
    }, 500);
  }
  function sende(name, daten) {
    var a = api();
    if (a) {
      try { a.publish(name, daten); } catch (e) { /* still */ }
      return;
    }
    warte.push([name, daten]);
    if (warte.length === 1) nachreichen();
  }

  function artikel(el) {
    var a = el && el.closest ? el.closest('a[href*="/products/"]') : null;
    if (!a) return null;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (!m) return null;
    var karte = a.closest('[data-veron-jetzt]');
    return { item_id: m[1], saison_jetzt: karte ? karte.getAttribute('data-veron-jetzt') : '' };
  }

  function artikelListe(bereich) {
    var aus = [], gesehen = {};
    var links = bereich.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var x = artikel(links[i]);
      if (x && !gesehen[x.item_id]) { gesehen[x.item_id] = 1; aus.push(x); }
    }
    return aus;
  }

  function daten(b) {
    return { promotion_name: b.getAttribute('data-veron-promo') || '', creative_slot: b.getAttribute('data-veron-promo-slot') || '' };
  }

  // Menge gesehener Elemente: WeakSet (neu gerenderte Schubfach-Inhalte werden frei), sonst Liste.
  function menge() {
    if (typeof window.WeakSet === 'function') { var w = new window.WeakSet(); return { hat: function (x) { return w.has(x); }, dazu: function (x) { w.add(x); } }; }
    var l = [];
    return { hat: function (x) { return l.indexOf(x) >= 0; }, dazu: function (x) { l.push(x); } };
  }

  function start() {
    var gemeldet = menge(), beobachtet = menge(), io = null;
    function ansicht(b) {
      if (gemeldet.hat(b) || !b.getAttribute('data-veron-promo')) return;
      gemeldet.dazu(b);
      var d = daten(b);
      d.items = artikelListe(b);
      sende('veron_promotion_view', d);
    }
    if ('IntersectionObserver' in window) {
      io = new window.IntersectionObserver(function (eintraege) {
        for (var j = 0; j < eintraege.length; j++) {
          if (eintraege[j].isIntersecting) { ansicht(eintraege[j].target); io.unobserve(eintraege[j].target); }
        }
      }, { threshold: 0.5 });
    }
    // VERON-MESSUNG-SPAETER: Flaechen in wurzel (und wurzel selbst) beobachten - beim Start und fuer jeden spaeter
    // eingefuegten Knoten (Schubfach-Abschnitt, nachgeladene Empfehlungen)
    function beobachte(wurzel) {
      if (!io || !wurzel) return;
      var liste = [];
      if (typeof wurzel.getAttribute === 'function' && wurzel.getAttribute('data-veron-promo') != null) liste.push(wurzel);
      if (typeof wurzel.querySelectorAll === 'function') {
        var innen = wurzel.querySelectorAll('[data-veron-promo]');
        for (var k = 0; k < innen.length; k++) liste.push(innen[k]);
      }
      for (var i = 0; i < liste.length; i++) {
        if (!beobachtet.hat(liste[i])) { beobachtet.dazu(liste[i]); io.observe(liste[i]); }
      }
    }
    beobachte(document);
    if (io && typeof window.MutationObserver === 'function' && document.documentElement) {
      new window.MutationObserver(function (aenderungen) {
        for (var a = 0; a < aenderungen.length; a++) {
          var neu = aenderungen[a].addedNodes || [];
          for (var n = 0; n < neu.length; n++) { if (neu[n] && neu[n].nodeType === 1) beobachte(neu[n]); }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
    document.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var link = t.closest('a[href]');
      var b = t.closest('[data-veron-promo]');
      if (!link || !b || !b.getAttribute('data-veron-promo')) return;
      var d = daten(b);
      d.link_url = link.getAttribute('href');
      d.item = artikel(link);
      sende('veron_promotion_select', d);
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
